function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Fragment } from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import IconButton from "@mui/material/IconButton";
import Grid from "../../layout/Grid";
// Limitless imports
import Star from "@limitless/icons/Star";
import StarBorder from "@limitless/icons/StarBorder";
import Tooltip from "@mui/material/Tooltip";
import { aiStar } from "@limitless/images";
export const createInitialState = max => {
  const initialState = {};
  let i = 0;
  for (i; i < max; i++) {
    initialState[i] = false;
  }
  return initialState;
};
const StarRating = ({
  onClick,
  rating,
  maxScore = 5,
  disabled = false,
  fontSize = 30,
  reasoning,
  aiUpdated
}) => {
  const classes = useStyles();
  const [localRating, setLocalRating] = React.useState(rating);
  const [stars, setStars] = React.useState(createInitialState(maxScore));
  const [hover, setHover] = React.useState(false);
  React.useEffect(() => {
    const val = rating || localRating;
    updateStars(val - 1);
  }, []);
  React.useEffect(() => {
    setLocalRating(rating);
    updateStars(rating - 1);
  }, [rating]);
  const updateStars = hoverIndex => {
    const newStars = {};
    Object.keys(stars).map(key => {
      newStars[key] = false;
      if (key <= hoverIndex) {
        newStars[key] = true;
      }
    });
    setStars(newStars);
  };
  const handleMouseOut = hoverIndex => {
    Object.keys(stars).map(key => {
      if (key <= hoverIndex) {
        if (localRating <= parseInt(key) || !localRating) {
          stars[key] = false;
        } else {
          stars[key] = true;
        }
      } else if (localRating > parseInt(key)) {
        stars[key] = true;
      }
    });
    setStars({
      ...stars
    });
    setHover(false);
  };
  const addEvents = key => {
    const updateFunc = () => {
      updateStars(key);
      setHover(true);
    };
    const changeScoreFunc = () => {
      updateStars(Number(key), false);
      setLocalRating(Number(key) + 1);
      onClick(Number(key) + 1);
      setHover(false);
    };
    if (!disabled) {
      return {
        onMouseOver: updateFunc,
        onFocus: updateFunc,
        onClick: changeScoreFunc,
        onMouseOut: () => handleMouseOut(key)
      };
    }
    return {};
  };
  return /*#__PURE__*/React.createElement(Grid, {
    rating: localRating,
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(Fragment, null, Object.keys(stars).map((key, index) => {
    const star = stars[key];
    return /*#__PURE__*/React.createElement(IconButton, _extends({
      id: `star-ratings-icon-button-${index}`,
      key: key,
      disabled: disabled
    }, addEvents(key), {
      size: "large"
    }), star ? /*#__PURE__*/React.createElement(Star, {
      className: `${classes.star} ${hover ? classes.hoverStyle : ""} ${index !== Object.keys(stars).length - 1 ? classes.leftSpacing : ""}`,
      style: {
        fontSize
      }
    }) : /*#__PURE__*/React.createElement(StarBorder, {
      key: key,
      className: `${classes.star} ${index !== Object.keys(stars).length - 1 ? classes.leftSpacing : ""}`,
      style: {
        fontSize
      }
    }));
  })), aiUpdated && reasoning && /*#__PURE__*/React.createElement(Tooltip, {
    title: reasoning
  }, /*#__PURE__*/React.createElement("img", {
    src: aiStar,
    alt: "AI Star",
    style: {
      width: "20px",
      height: "20px"
    }
  })));
};
const useStyles = makeStyles(({
  palette
}) => {
  return {
    star: {
      color: palette.warning.light
    },
    hoverStyle: {
      opacity: 0.8
    },
    leftSpacing: {
      paddingRight: 8
    }
  };
});
export default StarRating;
StarRating.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  rating: PropTypes.number,
  maxScore: PropTypes.number,
  fontSize: PropTypes.number,
  reasoning: PropTypes.string,
  aiUpdated: PropTypes.bool
};